import React, { useState } from "react";
import { FiUpload } from "react-icons/fi"; // Import the upload icon
import "react-quill/dist/quill.snow.css"; // Import the styles for React Quill
import ReactQuill from "react-quill";
import { useDispatch } from "react-redux";
import { addLeadershipMessage } from "../redux/actions/aboutUsActions";
// import DOMPurify from "dompurify";

export default function AddMessageForm({ title }) {
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    message_type: "",
    name: "",
    designation: "",
    message: "",
    file: null, // Store only the actual file here
  });

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      [{ font: [] }],
      ["bold", "italic", "underline"],
      [{ align: [] }],
      ["clean"],
    ],
  };

  const formats = ["font", "header", "bold", "italic", "underline", "align"];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Set the file as the full File object for preview, but only send the name in FormData
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData({ ...formData, file, imagePreview: reader.result });
      };
      reader.readAsDataURL(file);
    }
  };
  const handleQuillChange = (content) => {
    setFormData({ ...formData, message: content });
  };

  const stripHtml = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();

     // Sanitize or extract plain text
    // const sanitizedMessage = DOMPurify.sanitize(formData.message);

    // // You can also extract plain text using a temporary DOM element
    // const plainText = sanitizedMessage.replace(/<[^>]*>/g, "");
    const plainMessage = stripHtml(formData.message);

    if (!formData.message_type || !formData.name || !formData.designation || !formData.file) {
      alert("All fields are required!");
      return;
    }
    if (!plainMessage.trim()) {
      alert("Message is required.");
      return;
    }
  
    const formDataToSend = new FormData();
    formDataToSend.append("message_type", formData.message_type);
    formDataToSend.append("name", formData.name);
    formDataToSend.append("designaion", formData.designation);
    formDataToSend.append("message",  formData.message);
    if (formData.file) {
      formDataToSend.append("file", formData.file);
    }
  
    dispatch(
      addLeadershipMessage(formDataToSend, () => {
        alert("Leadership message added successfully!");
        window.location.reload(); // Refresh the page
      })
    );
  };
  
  
  

  return (
    <div className="p-4 mb-6 bg-white rounded-lg shadow-md">
      <h2 className="mb-4 text-xl font-semibold text-gray-700">{title}</h2>
      <form onSubmit={handleSubmit}>
        {/* Row 1: Position, Name, Designation */}
        <div className="grid grid-cols-3 gap-4 mb-4">
          {/* Position Dropdown */}
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-600" htmlFor="message_type">
              Position
            </label>
            <select
              id="message_type"
              name="message_type"
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
              value={formData.message_type}
              onChange={handleInputChange}
            >
              <option value="" disabled>
                Select Position
              </option>
              <option value="President">President</option>
              <option value="Vice President">Vice President</option>
              <option value="CEO">CEO</option>
              <option value="Director">Director</option>
            </select>
          </div>

          {/* Name Input */}
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-600" htmlFor="name">
              Name
            </label>
            <input
              id="name"
              name="name"
              type="text"
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
              value={formData.name}
              onChange={handleInputChange}
            />
          </div>

          {/* Designation Input */}
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-600" htmlFor="designation">
              Title
            </label>
            <input
              id="designation"
              name="designation"
              type="text"
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
              value={formData.designation}
              onChange={handleInputChange}
            />
          </div>
        </div>

        {/* Row 2: Image Drop Field & Message Input */}
        <div className="grid grid-cols-3 gap-4 mb-4">
          {/* Image Drop Field */}
          <div className="flex flex-col items-center justify-center w-full h-[225px] p-5 border border-gray-300 border-dashed rounded-md relative">
            <input
              type="file"
              name="file"
              accept=".jpg, .png,.webp, .jpeg"
              className="absolute inset-0 opacity-0 cursor-pointer"
              onChange={handleImageUpload}
            />
            {formData.imagePreview ? (
              <div className="w-full h-full">
                <img
                  src={formData.imagePreview}
                  alt="Uploaded Preview"
                  className="object-contain w-full h-full rounded-md"
                />
              </div>
            ) : (
              <>
                <FiUpload className="w-10 h-10 p-2 mb-3 text-gray-400 bg-gray-100 border-none rounded-md" />
                <p className="text-black">Drag and drop image here</p>
                <p className="text-sm text-center text-gray-400">
                        Any size of image, will automatically adjust to the frame 
                        </p>
                <button
                  type="button"
                  className="px-4 py-2 mt-2 text-[#92288C] font-semibold bg-[#92288C] bg-opacity-10 rounded-md"
                  onClick={() => document.querySelector("input[name='file']").click()}
                >
                  Browse Image
                </button>
              </>
            )}
          </div>

          {/* Message Input (React Quill) */}
          <div className="col-span-2 h-[200px]">
            <label className="block mb-1 text-sm font-medium text-gray-600" htmlFor="message">
              Message
            </label>
            <div className="h-full overflow-hidden border border-gray-300 rounded-md focus-within:border-gray-400">
              <ReactQuill
                id="message"
                value={formData.message}
                onChange={handleQuillChange}
                theme="snow"
                modules={modules}
                formats={formats}
                className="h-[300px]"
                placeholder="Enter your message here..."
              />
            </div>
          </div>
        </div>

        {/* Submit Button */}
        <div className="flex justify-end">
          <button
            type="submit"
            className="px-6 py-2 text-white bg-[#92288C] rounded-md hover:bg-[#6C0B67]"
          >
            Add
          </button>
        </div>
      </form>
    </div>
  );
}
